import { FormSectionLangFieldMap } from '@/types'
import { FieldType, SupportedLanguage } from '@/enum'

export const CONTACT_DETAILS_DATA: FormSectionLangFieldMap = {
  [SupportedLanguage.English]: [
    {
      id: '0b707f68-4ca4-4aab-b0b5-b9427976f10e',
      label: 'Contact Person',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'Shivaji Verma',
      identifier: 'contactname',
    },
    {
      id: '2e45477e-8c08-4fcd-af66-fa46f1650880',
      label: 'Contact Number',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: 'd4bc2b92-1513-4506-a391-a1f1b175c6e4',
      label: 'Residential Address',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, Premsagar Society, LBS Marg, Kurla (West), Mumbai - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Hindi]: [
    {
      id: '7b871ef4-9eaa-4122-a6ae-83d3088aecb4',
      label: 'संपर्क व्यक्ति',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'शिवाजी वर्मा',
      identifier: 'contactname',
    },
    {
      id: '12e6cb06-1622-420d-a5ed-06e34bca5e70',
      label: 'संपर्क नंबर',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: '8a7df25f-c3e7-4943-a933-0da12ba20fa5',
      label: 'आवासीय पता',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, प्रेमसागर सोसाइटी, एलबीएस मार्ग, कुर्ला (पश्चिम), मुंबई - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Marathi]: [
    {
      id: '30715884-80b4-4cde-ad89-87f4b952a91e',
      label: 'संपर्क व्यक्ती',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'शिवाजी वर्मा',
      identifier: 'contactname',
    },
    {
      id: 'de116458-f981-4121-9f46-d2e87746bb07',
      label: 'मो.नं.',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '९०९०९०९०९०',
      identifier: 'contactnumber',
    },
    {
      id: '4c1282ec-e3b6-4de9-aa18-0e2851926b9a',
      label: 'निवासी पत्ता',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '५०३, प्रेमसागर सोसायटी, एलबीएस मार्ग, कुर्ला (पश्चिम), मुंबई - ४०००७०',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Gujarati]: [
    {
      id: '5fbad4ef-a15a-4ba4-adf7-7b992c209d1d',
      label: 'સંપર્ક વ્યક્તિ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'શિવાજી વર્મા',
      identifier: 'contactname',
    },
    {
      id: '51bf3948-5093-4411-baad-446273a01a04',
      label: 'સંપર્ક નંબર',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: '166775ef-5176-46c9-aa09-b1cb75be8494',
      label: 'રહેણાંક સરનામું',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, પ્રેમસાગર સોસાયટી, એલ.બી.એસ. માર્ગ, કુર્લા (પશ્ચિમ), મુંબઈ - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Bengali]: [
    {
      id: '3ef3df1f-66af-45d1-9dc2-26736b617b99',
      label: 'যোগাযোগের ব্যক্তি',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'শিবাজী ভের্মা',
      identifier: 'contactname',
    },
    {
      id: 'afb445a4-3ba8-49d2-9a19-82caf2af88c4',
      label: 'যোগাযোগ নম্বর',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: '6e131622-889f-47bd-a507-de01b7f46829',
      label: 'বাসস্থান ঠিকানা',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, প্রিমসাগর সোসাইটি, এলবিএস মার্গ, কুরলা (পশ্চিম), মুম্বাই - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Telugu]: [
    {
      id: '20896976-16d1-4d4b-9f69-7c6ffff3b7dd',
      label: 'సంప్రదించవలసిన వ్యక్తి',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'శివాజీ వర్మ',
      identifier: 'contactname',
    },
    {
      id: '213a0028-bd43-4ba3-9099-bb576ca0e8af',
      label: 'సంప్రదించవలసిన నంబర్',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: '849faf9e-f0b7-4c3d-b8b6-4c2acd383ece',
      label: 'నివాస చిరునామా',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, ప్రేమ్‌సాగర్ సొసైటీ, ఎల్‌బిఎస్ మార్గ్, కుర్లా (పశ్చిమ), ముంబై - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Kannada]: [
    {
      id: 'abcaeec9-53d4-4033-a53d-3cde4ab01706',
      label: 'ಸಂಪರ್ಕ ವ್ಯಕ್ತಿ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಶಿವಾಜಿ ವರ್ಮಾ',
      identifier: 'contactname',
    },
    {
      id: 'fc96f036-a099-4c5c-970f-7a5ce83daa9a',
      label: 'ಸಂಪರ್ಕ ಸಂಖ್ಯೆ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: '2b86ce07-d4ef-4665-b50c-ce88ec5a1e80',
      label: 'ನಿವಾಸದ ವಿಳಾಸ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, ಪ್ರೇಮಸಾಗರ್ ಸೊಸೈಟಿ, ಎಲ್‌ಬಿಎಸ್ ಮಾರ್ಗ, ಕುρಳಾ (ಪಶ್ಚಿಮ), ಮುಂಬೈ - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Tamil]: [
    {
      id: '684e03f5-75f7-47d7-b158-08758268316e',
      label: 'தொடர்புக்குவைப்பவர்',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'சிவாஜி வெர்மா',
      identifier: 'contactname',
    },
    {
      id: '1f8cccc9-4405-4fec-adf4-48a2373da07b',
      label: 'தொடர்பு எண்',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: '9b397d27-92b6-48d7-87b4-fdb971459e6e',
      label: 'வசிப்பது தொடர்பான முகவரி',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, பிரேம்சாகர் சొசைட்டி, எல்.பி.எஸ் மார்க், குர்லா (மேற்கு), மும்பை - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Odia]: [
    {
      id: '61fbe5c6-628f-4ff2-92b8-957585dde5c1',
      label: 'ସଂପର୍କ ବ୍ୟକ୍ତି',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ଶିବାଜୀ ବର୍ମା',
      identifier: 'contactname',
    },
    {
      id: '911a5590-88a3-40c2-9a27-0a1bfbc73a35',
      label: 'ସଂପର୍କ ସଂଖ୍ୟା',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: 'fdcdca1d-3c9e-4de1-a420-6b2b9a97eb66',
      label: 'ନିବାସୀ ଠିକଣା',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, ପ୍ରେମସାଗର ସମିତି, LBS ମାର୍ଗ, କୁର୍ଲା (ପଶ୍ଚିମ), ମୁମ୍ବାଇ - 400070',
      identifier: 'address',
    },
  ],
  [SupportedLanguage.Malayalam]: [
    {
      id: '126dce85-15e8-463b-b19e-0b31cfb30707',
      label: 'ബന്ധപ്പെടേണ്ട വ്യക്തി',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ശിവാജി വർമ്മ',
      identifier: 'contactname',
    },
    {
      id: '19d7caa5-c0b8-4a34-aded-a155e0fb18e8',
      label: 'ബന്ധപ്പെടാനുള്ള നമ്പർ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '9090909090',
      identifier: 'contactnumber',
    },
    {
      id: 'ae16114f-28c9-44a7-9a25-2616bac1e409',
      label: 'താമസ വിലാസം',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: '503, പ്രേംസാഗർ സൊസൈറ്റി, എൽ.ബി.എസ് റോഡ്, കുർള (വെസ്റ്റ്), മുംബൈ - 400070',
      identifier: 'address',
    },
  ],
}
